import { render, staticRenderFns } from "./SelectedTemplateBlock.vue?vue&type=template&id=b73141e0&scoped=true&"
import script from "./SelectedTemplateBlock.vue?vue&type=script&lang=js&"
export * from "./SelectedTemplateBlock.vue?vue&type=script&lang=js&"
import style0 from "./SelectedTemplateBlock.vue?vue&type=style&index=0&id=b73141e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73141e0",
  null
  
)

export default component.exports